<template>
  <div>
    <div class="login-page">
      <top @topLogin="topLogin"
           @TopReg="topLogin"
           ref="top"></top>
      <div class="login">
        <div class="title"
             v-if="!forgotFlag">
          {{ type == "reg" ? "用户注册" : "用户登录" }}
        </div>
        <div class="title"
             v-if="forgotFlag">
          {{ "忘记密码" }}
        </div>

        <div class="loginForm"
             v-if="loginSelect && !forgotShow">
          <div v-if="type != 'reg'">
            <div v-if="QALogin"
                 style="text-align: center">
              <el-tooltip class="item"
                          effect="dark"
                          content="账号密码登录"
                          placement="top">
                <img class="switch"
                     src="../../assets/img/zhanghao.png"
                     alt=""
                     @click="QALogin = !QALogin" />
              </el-tooltip>
              <!-- 
              <img
                style="width: 90%"
                src="https://res.wx.qq.com/op_res/fW6MmqxGxJAzfluM9TDV58JifCanyliNg-y026kpPVVrkfEAACN6b021LbOZD3pa"
                alt=""
              /> -->
              <div id="login_container"></div>
            </div>
            <div v-else>
              <el-tooltip class="item"
                          effect="dark"
                          content="微信扫码登录更便捷"
                          placement="top">
                <img class="switch_second"
                     src="../../assets/img/saoma.png"
                     alt=""
                     @click="switchType" />
              </el-tooltip>
              <img />
              <div class="has-feedback"
                   style="text-align: center">
                <ul class="nav nav-tabs"
                    role="tablist">
                  <li role="presentation"
                      @click="LoginByPwd()"
                      :class="active == 0 ? 'active' : ''">
                    <a href="#"
                       role="tab"
                       data-toggle="tab"
                       style="text-align: center">普通登录</a>
                  </li>
                  <li @click="LoginByCode()"
                      :class="active == 1 ? 'active' : ''">
                    <a href="#"
                       role="tab"
                       data-toggle="tab"
                       style="text-align: center">短信验证登录</a>
                  </li>
                </ul>
              </div>

              <el-form :model="formInfo"
                       :rules="rules"
                       size="medium"
                       ctIdList
                       ref="loginForm"
                       label-width="0"
                       label-position="top"
                       class="form">
                <div v-if="active == 0">
                  <el-form-item prop="account">
                    <el-input v-model="formInfo.account"
                              auto-complete="off"
                              placeholder="请输入账号"
                              prefix-icon="el-icon-user-solid"></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input type="password"
                              v-model="formInfo.password"
                              auto-complete="off"
                              placeholder="请输入密码"
                              prefix-icon="el-icon-lock"></el-input>
                  </el-form-item>
                  <el-form-item v-if="captchaImg"
                                prop="captcha">
                    <div class="captcha-input">
                      <el-input v-model="formInfo.captcha"
                                maxlength="4"
                                placeholder="请输入验证码">登陆</el-input>
                      <img :src="`data:image/png;base64,${captchaImg}`"
                           alt=""
                           @click="getCaptcha" />
                    </div>
                  </el-form-item>
                </div>
                <div v-if="active == 1">
                  <el-form-item prop="tel">
                    <el-input v-model="formInfo.tel"
                              placeholder="请输入手机号"
                              maxlength="11"
                              prefix-icon="el-icon-mobile-phone"></el-input>
                  </el-form-item>
                  <el-form-item prop="verificationCode">
                    <div class="code-input">
                      <el-input v-model="formInfo.verificationCode"
                                maxlength="6"
                                placeholder="请输入短信验证码"></el-input>
                      <el-button type="primary"
                                 class="btn"
                                 :disabled="!!seconds"
                                 @click="verifyPhone('loginForm')">
                        <span v-if="!seconds">获取验证码</span>
                        <span v-else>{{ seconds }}s后获取</span>
                      </el-button>
                    </div>
                  </el-form-item>
                </div>
              </el-form>

              <div v-if="active == 0"
                   class="actionBar">
                <el-checkbox style="color: white"
                             v-model="formInfo.isRememberMe">记住账号</el-checkbox>
                <span style="cursor: pointer"
                      @click="forgotPwd">忘记密码</span>
              </div>
              <div class="submit-button">
                <el-button :loading="loginLoading"
                           @click="login('loginForm')"
                           style="
                    background-color: #3c8dbc;
                    border-color: #367fa9;
                    color: #fff;
                    width: 100%;
                  ">登录</el-button>
              </div>
              <div style="text-align: center; color: #fff; margin-top: 15px">
                <span style="cursor: pointer"
                      @click="$router.push('/loginform?type=reg')">
                  还没有帐号？快去注册一个吧！</span>
              </div>
            </div>
          </div>
          <div v-else>
            <div style="
                text-align: center;
                color: white;
                font-size: 18px;
                margin-bottom: 10px;
              ">
              请用微信扫描此二维码
            </div>
            <div v-if="$shareType == 2">
              <div v-if="!imgPath"
                   style="width: 250px; height: 250px; margin: 0 auto"></div>
              <img v-else
                   style="width: 100%; height: 100%"
                   :src="imgPath"
                   alt="" />
            </div>

            <div id="qrcode"
                 ref="qrcode"
                 v-if="$shareType == 1"></div>
            <div @click="$router.push('/loginform?type=log')"
                 style="
                text-align: center;
                color: white;
                margin-top: 15px;
                cursor: pointer;
                text-decoration: underline;
              ">
              已注册，立即登录
            </div>
          </div>
        </div>

        <div class="identityContainer"
             v-if="!loginSelect">
          <div style="cursor: pointer">
            <i class="el-icon-arrow-left"
               @click="goBack()">返回</i>
          </div>
          <div class="selectIdList">
            <h2>
              {{ forgotFlag ? "选择需要修改密码的身份" : "选择你的身份" }}
            </h2>
            <div class="scroList">
              <div class="idList"
                   v-for="(item, i) in companyList"
                   :key="i"
                   @click="goIndex(item.id)">
                <span class="loginTop"
                      v-if="i == 0">上次登录</span>
                <div class="list-left">
                  <img v-if="item.selfImagePath"
                       :src="item.selfImagePath"
                       alt="" />
                  <img v-else
                       src="../../assets/img/avatar.png"
                       alt="" />

                  <span>{{
                    item.companyName ? item.companyName : "个人账户"
                  }}</span>
                </div>
                <i class="el-icon-right"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="forgotForm"
             v-if="forgotShow">
          <el-form :model="formInfo"
                   :rules="rules"
                   size="medium"
                   ctIdList
                   ref="loginForm"
                   label-width="0"
                   label-position="top"
                   class="form">
            <el-form-item prop="account">
              <el-input v-model="formInfo.account"
                        auto-complete="off"
                        placeholder="请输入账号"
                        prefix-icon="el-icon-user-solid"></el-input>
            </el-form-item>
            <el-form-item prop="tel">
              <el-input v-model="formInfo.tel"
                        placeholder="请输入手机号"
                        maxlength="11"
                        prefix-icon="el-icon-mobile-phone"></el-input>
            </el-form-item>
            <el-form-item prop="verificationCode">
              <div class="code-input">
                <el-input v-model="formInfo.verificationCode"
                          maxlength="6"
                          placeholder="请输入短信验证码"></el-input>
                <el-button type="primary"
                           class="btn"
                           :disabled="!!seconds"
                           @click="verifyPhone('loginForm')">
                  <span v-if="!seconds">获取验证码</span>
                  <span v-else>{{ seconds }}s后获取</span>
                </el-button>
              </div>
            </el-form-item>
          </el-form>
          <div class="submit-button">
            <el-button :loading="loginLoading"
                       @click="forgetPasswod('loginForm')"
                       style="
                background-color: #3c8dbc;
                border-color: #367fa9;
                color: #fff;
                width: 100%;
              ">确 认</el-button>
          </div>
          <div @click="topLogin"
               style="
              text-align: center;
              color: white;
              margin-top: 15px;
              cursor: pointer;
              text-decoration: underline;
            ">
            返回登录
          </div>

        </div>
        <logoFoot />

      </div>

    </div>
    <Foot />
    <el-dialog title="请输入图像验证码"
               :visible.sync="telVisible"
               width="300px"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="$set(telLogin, 'captcha', '')">
      <div style="display: flex">
        <el-input v-model="telLogin.captcha"
                  maxlength="4"
                  placeholder="请输入验证码">登陆</el-input>
        <img style="margin-left: 15px"
             :src="`data:image/png;base64,${telLogin.captchaImg}`"
             alt=""
             @click="getCaptcha('tel')" />
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="(telVisible = false), $set(telLogin, 'captcha', '')">取 消</el-button>
        <el-button type="primary"
                   @click="SendSms">确 定</el-button>
      </span>
    </el-dialog>
    <ImproveInformation :visible="ImproveVisible"
                        :companyList="companyList"
                        :isReg="isReg"
                        :userId="userId"
                        :tel="regTell"
                        @finish="finish"
                        @close="closeImprove" />
    <el-dialog title="修改密码"
               :visible.sync="changePwdVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="350px">
      <el-form :model="form"
               :rules="rules"
               size="small"
               ref="form"
               label-width="81px"
               label-position="left"
               @close="form = {}">
        <el-form-item label="新密码"
                      prop="passWord">
          <el-input v-model="form.passWord"
                    type="password"
                    show-password
                    placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码"
                      prop="checkPassWord">
          <el-input v-model="form.checkPassWord"
                    type="password"
                    show-password
                    placeholder="请输入再次新密码"></el-input>
        </el-form-item>
        <div style="text-align: center">
          <el-button @click="
              changePwdVisible = false;
              form = {};
            ">取 消</el-button>
          <el-button type="primary"
                     @click="changePassword('form')">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Foot from "./_foot";
import QRCode from "qrcodejs2";
import top from "./_top_menu";
import logoFoot from "./logoFoot";
//完善个人资料
import ImproveInformation from "./ImproveInformation";
import { GetUnlimitedQRCodeMinix, countdown } from "@/utils/mixin";

import { baseUrl } from "../../request/url";
export default {
  components: {
    Foot,
    top,
    ImproveInformation,
    logoFoot
  },
  mixins: [
    GetUnlimitedQRCodeMinix,
    countdown("seconds", "setCountdown", "LoginSMSTime"),
  ],
  data () {
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      loginSelect: true,
      flag: true,
      formInfo: {
        account: "",
        password: "",
        captcha: "",
        isRememberMe: false,
      },
      findPswForm: {
        captchaImg: "",
      },
      active: 0,
      testDialogVisible: false,
      companyList: [],
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value.length < 6) {
                callback(new Error("请至少输入6位密码"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        passWord: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const check =
                /^(?=.{8})(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]).*$/;
              if (check.test(value)) {
                callback();
              } else {
                callback(new Error("至少8位，数字+大小写字母+特殊字符"));
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        checkPassWord: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (this.form.passWord !== value) {
                callback(new Error("两次输入密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value.length < 4) {
                callback(new Error("请至少输入4位账号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        tel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        verificationCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        cname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
      toggleType: "login",
      captchaImg: "",
      uuid: "null",
      loginErrorCount: 0,
      loginLoading: false,

      dialogVisible: false,
      sendverify: {
        captchaImg: "",
        captcha: "",
        uuid: "",
      },
      telLogin: {
        mobile: "",
        captchaImg: "",
        captcha: "",
        uuid: "",
      },
      nextStep: false,
      title: "找回密码",
      showTimeout: false,
      count: 0,
      timer: null,
      captchaRule: [
        { required: true, message: "请输入验证码", trigger: "blur" },
      ],
      time: "",
      verifyAccountLoading: false,
      LoginSMSTime: "",
      registerLoading: false,
      sendSMSLoading: false,
      type: "log",
      QRloading: false,
      QALogin: true,
      imgPath: "",
      telVisible: false,
      forgotShow: false,
      forgotFlag: false,
      changePwdVisible: false,
      form: {},
      ids: [],
      ImproveVisible: false,
      isReg: false,
      regTell: "",
      userId: "",
    };
  },
  created () {
    var l_info = window.localStorage.getItem("lap");
    if (l_info) {
      var info = JSON.parse(window.decodeURIComponent(window.atob(l_info)));
      this.formInfo.account = info.a;
      this.formInfo.isRememberMe = true;
    }
    //注册小程序码
    if (window.localStorage.getItem("register_img")) {
      this.imgPath = window.localStorage.getItem("register_img");
    }
    //倒计时
    this.LoginSMSTime = window.localStorage.getItem("LoginSMSTime")
      ? window.localStorage.getItem("LoginSMSTime")
      : 120;
    if (window.localStorage.getItem("LoginSMSTime")) {
      this.setCountdown(window.localStorage.getItem("LoginSMSTime"));
    }
    const codeRequired = Cookies.get("codeRequired");
    if (codeRequired == "true") this.loginErrorCount = 3;
    window.addEventListener("keydown", (e) => {
      if (
        e.key === "Enter" &&
        this.toggleType === "login" &&
        this.loginSelect &&
        !this.forgotFlag
      ) {
        this.login("loginForm");
      }
    });
    this.time = new Date().getFullYear();
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.QALogin && !this.$route.query.code) {
      this.$nextTick(() => {
        this.LoginQR();
      });
    }
    if (this.$route.query.type == "reg") {
      this.$nextTick(() => {
        this.getQRCode();
      });
    }
  },
  mounted () {
    if (this.$route.query.code) {
      console.log(this.$route.query.code);
      this.LoginByWeChatScanQRcode(this.$route.query.code);
    }
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el) {
        el.focus();
      },
    },
  },
  watch: {
    $route: function (to, from) {
      this.type = this.$route.query.type;
      if (this.$route.query.type == "reg") {
        this.$nextTick(() => {
          this.getQRCode();
        });
      }
      if (this.$route.query.type == "log") {
        this.$nextTick(() => {
          this.LoginQR();
        });
      }
    },
    loginErrorCount (val) {
      if (val >= 2) {
        this.getCaptcha();
        this.setCookie();
        this.rules.captcha = this.captchaRule;
      }
    },
    QALogin (v) {
      if (v) {
        this.$nextTick(() => {
          this.LoginQR();
        });
      }
    },
  },
  methods: {
    closeImprove () {
      this.ImproveVisible = false;
      this.LoginQR();
    },
    //切换登录类型
    switchType () {
      this.QALogin = !this.QALogin;
      this.$nextTick(() => {
        this.LoginQR();
      });
    },
    LoginQR () {
      var obj = new WxLogin({
        self_redirect: false,
        id: "login_container",
        appid: "wx473b117306026468",
        scope: "snsapi_login",
        redirect_uri: encodeURIComponent(
          "https://nwoyou.rayqee.com/loginform?type=log"
        ),
        state: "",
        style: "white",
        href: "",
      });
    },
    topLogin () {
      this.forgotFlag = false;
      this.forgotShow = false;
      this.loginSelect = true;
      this.changePwdVisible = false;
      this.reSet();
    },
    //确认修改密码
    changePassword (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        const sendData = {
          ids: this.ids,
          passWord: this.form.passWord,
          checkPassWord: this.form.checkPassWord,
        };
        this.$api.user.RetrievePassword(sendData).then((res) => {
          if (res.code === 0) {
            this.forgotFlag = false;
            this.forgotShow = false;
            this.loginSelect = true;
            this.changePwdVisible = false;
            this.reSet();
            this.$message.success("修改成功");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    //返回
    goBack () {
      if (this.forgotFlag) {
        this.loginSelect = true;
        this.forgotShow = true;
      } else {
        this.loginSelect = true;

        this.$nextTick(() => {
          this.LoginQR();
        });
      }
    },
    reSet () {
      this.formInfo = {
        account: "",
        password: "",
        captcha: "",
        isRememberMe: false,
      };
    },
    //点击忘记密码
    forgotPwd () {
      this.forgotShow = true;
      this.forgotFlag = true;
      this.reSet();
    },
    // 密码登录
    LoginByPwd () {
      this.active = 0;
      this.$refs.loginForm.clearValidate();
    },
    // 短信登录
    LoginByCode () {
      this.active = 1;
      this.$refs.loginForm.clearValidate();
    },
    //获取手机验证码
    verifyPhone (formName) {
      this.$refs[formName].validateField("tel", (valid) => {
        console.log(valid);
        if (valid == "请输入手机号" || valid == "手机号不正确") return;
        this.telVisible = true;
        this.getCaptcha("tel");
      });
    },
    SendSms () {
      if (this.telLogin.captcha.length < 4) {
        this.$message.warning("请输入4位验证码");
        return;
      }
      let sendData = {
        mobile: this.formInfo.tel,
        uuid: this.telLogin.uuid,
        code: this.telLogin.captcha,
        msgType: this.forgotShow ? "forgot" : "LoginByNote",
      };
      this.$api.user.SendSms(sendData).then((res) => {
        if (res.code === 0) {
          this.$message.success("短信发送成功");
          this.telVisible = false;
          this.$set(this.telLogin, "captcha", "");
          this.setCountdown(this.LoginSMSTime);
          console.log(res);
        } else {
          this.$set(this.telLogin, "captcha", "");
          this.getCaptcha("tel");
          this.$message.error(res.msg);
        }
      });
    },
    getQRCode () {
      if (this.$shareType == 1) {
        console.log(baseUrl.website + "/#/pages/home/register");
        this.$nextTick(() => {
          let qrcode = new QRCode("qrcode", {
            width: 278, // 设置宽度，单位像素
            height: 250, // 设置高度，单位像素
            text: baseUrl.website + "/#/pages/home/register",
            // 设置二维码内容或跳转地址
          });
        });
      }
      if (this.$shareType == 2) {
        if (!this.imgPath) {
          this.QRloading = true;
          let sendData = {
            page: "pages/my/self-info",
            check_path: false,
            width: 300,
            scene: "reg",
          };
          this.GetUnlimitedQRCode(sendData).then((res) => {
            this.QRloading = false;
            this.imgPath = "data:image/png;base64," + res;
            window.localStorage.setItem("register_img", this.imgPath); //base64编码
          });
        }
      }
    },
    // 获取图片验证码
    getCaptcha (val) {
      this.$api.user.getVierificationCode().then((res) => {
        if (res.code === 0 && res.data) {
          if (val == "tel") {
            this.telLogin.captchaImg = res.data.img;
            this.telLogin.uuid = res.data.uuid;
          } else {
            this.captchaImg = res.data.img;
            this.uuid = res.data.uuid;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //登录判断（手机号登录和扫码登录）
    loginJudgment (res, type) {
      this.deleteCode();
      if (res.code === 0 && res.data.refultList.length != 0) {
        this.companyList = res.data.refultList;
        this.loginSelect = false;

        this.loginLoading = false;
      } else if (res.code == 4 && type == "tel") {
        //判断是否进过小程序
        if (!res.data.isEnterWeChat) {
          this.$message.error("当前手机号码未注册，请前往注册！");
          this.$refs.top.toReg();
        } else {
          this.$message.warning("请进行注册！");
          this.regTell = this.formInfo.tel;
          this.isReg = true;
          this.ImproveVisible = true;
          this.userId = res.data.userId;
        }
        this.loginLoading = false;
      } else if ((res.code == 1 || res.code == 0) && type == "QR") {
        //判断是否进过小程序
        if (!res.data.isEnterWeChat) {
          this.$message.error("当前手机号码未注册，请前往激活或注册！");
          this.$refs.top.toReg();
        } else {
          this.$message.warning("请进行注册！");
          this.regTell = res.data.tel;
          this.isReg = true;
          this.ImproveVisible = true;
          this.userId = res.data.userId;
        }
        this.loginLoading = false;
      } else {
        let msg = res.msg ? res.msg : "登录失败";
        this.$message.error(msg);
        this.loginLoading = false;
      }
      this.formInfo.verificationCode = "";
    },
    //扫码登录
    LoginByWeChatScanQRcode (code) {
      let sendData = {
        code: code,
      };
      this.$api.user.LoginByWeChatScanQRcode(sendData).then((res) => {
        this.loginJudgment(res, "QR");
      });
    },
    deleteCode () {
      // 假设当前 URL 为 /example?param1=value1&param2=value2
      // 删除地址栏中的 param1 参数

      // 获取当前地址栏参数对象
      let params = Object.assign({}, this.$route.query);

      // 删除指定参数
      delete params.code;
      delete params.state;

      // 构造新的 URL
      let path = this.$route.path;
      let query = new URLSearchParams(params).toString();
      let newUrl = query ? `${path}?${query}` : path;

      // 替换当前的历史记录，不进行页面跳转
      window.history.replaceState({}, "", newUrl);
    },
    login (formName) {
      // this.ImproveVisible = true;
      // return;
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.loginLoading = true;
        if (this.active == 0) {
          const sendData = {
            account: this.formInfo.account,
            password: this.formInfo.password,
            verificationCode: this.formInfo.captcha,
            uuid: this.uuid,
          };
          localStorage.setItem("lirm", this.formInfo.isRememberMe ? 1 : 0);
          this.$api.user.CompanyUserLogin(sendData).then((res) => {
            if (res.code === 0) {
              var isRememberMe = localStorage.getItem("lirm");
              if (isRememberMe == 1) {
                var _loginInfo = JSON.stringify({ a: sendData.account });
                window.localStorage.setItem(
                  "lap",
                  window.btoa(window.encodeURIComponent(_loginInfo))
                ); //base64编码
              } else {
                window.localStorage.removeItem("lap");
              }
              this.companyList = res.data.refultList;
              //进入选择身份
              this.loginSelect = false;
              this.loginLoading = false;
              this.loginErrorCount = 0;
              this.captchaImg = "";
              Cookies.remove("codeRequired");
            } else if (res.code == 4) {
              if (!res.data.isEnterWeChat) {
                this.$message.error("当前手机号码未注册，请点击注册！");
              }
            } else {
              let msg = res.msg ? res.msg : "登录失败";
              this.$message.error(msg);
              this.loginErrorCount = res.data;
              this.loginLoading = false;
            }
            this.$refs[formName].resetFields();
          });
        } else {
          let sendData = {
            tel: this.formInfo.tel,
            verificationCode: this.formInfo.verificationCode,
            smsMsgType: "LoginByNote",
          };
          this.$api.user.LoginByNoteVerificationCode(sendData).then((res) => {
            // this.$refs[formName].resetFields();
            this.loginJudgment(res, "tel");
          });
        }
      });
    },

    finish (value) {
      if (value == 1) {
        //完善资料
        this.$router.replace("/home");
      } else {
        //注册
        location.reload();
      }
      console.log(value);
    },
    // 判断是否需要补充资料
    determine (val) {
      if (val.isEnterPark == null) {
        //需要完善资料
        this.ImproveVisible = true;
      } else {
        //无需完善资料
        this.$router.replace("/home");
      }
    },
    //忘记密码点击确认
    forgetPasswod (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        const sendData = {
          account: this.formInfo.account,
          tel: this.formInfo.tel,
          verificationCode: this.formInfo.verificationCode,
          smsMsgType: "forgot",
        };
        this.$api.user.ForgetPasswod(sendData).then((res) => {
          if (res.code === 0) {
            this.loginSelect = true;
            this.forgotShow = true;
            // this.forgotFlag = true;
            // this.companyList = res.data;
            this.ids = res.data.map((v) => {
              return v.id;
            });
            this.changePwdVisible = true;
            this.loginErrorCount = 0;
            this.captchaImg = "";
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    // 选择身份
    goIndex (id) {
      if (this.forgotFlag) {
        //修改密码
        // this.ids[0] = id;
      } else {
        //登录
        this.loading = true;
        let sendData = new FormData();
        sendData.append("id", id);
        this.$api.user.GetLoginToken(sendData).then(async (res) => {
          if (res.code == 0) {
            console.log(res.data);
            this.getUserInfo(res.data.memberId);
            window.localStorage.setItem(
              "Authorization",
              JSON.stringify(res.data)
            );
            await this.CompanyDetail();
            //只有一个身份
            if (this.companyList && this.companyList.length == 1) {
              this.determine(this.companyList[0]);
            } else {
              this.$router.replace("/home");
            }
            // this.loading = false;
          } else {
            this.loading = false;

            this.$message.error(res.msg);
          }
        });
      }
    },
    async CompanyDetail () {
      await this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          window.localStorage.setItem(
            "CompanyDetail",
            JSON.stringify(res.data)
          );
          this.$store.commit("change", res.data);
          console.log(res);
        }
      });
    },

    async getUserInfo (memberId) {
      await this.$api.user.GetCompanyManageUserInfo(memberId).then((res) => {
        if (res.code === 0) {
          this.userInfo = res.data;
          delete this.userInfo.password;
          delete this.userInfo.password2;
          window.localStorage.setItem(
            "userInfo",
            JSON.stringify(this.userInfo)
          );
        }
      });
    },
    setCookie () {
      let seconds = 3600;
      let expires = new Date(new Date() * 1 + seconds * 1000);
      Cookies.set("codeRequired", "true", { expires: expires }); // 1小时后失效
    },
  },
  // beforeDestroy() {
  //   this.$api.posts.getNotChangeStateCandidate().then((res) => {
  //     if (res.Error === false) {
  //       if (res.Data && res.Data.length > 0) {
  //         this.$bus.$emit("showPromptDialog", res.Data);
  //       }
  //     }
  //   });
  // },
};
</script>
<style lang="less">
.login-page {
  .el-form-item__error {
    color: red;
  }
}
.actionBar {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: white;
  }
}
</style>
<style lang="less" scoped>
.login-page {
  width: 100%;
  background: url(../../assets/img/banner1.jpg) no-repeat;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  .login {
    margin: 0 auto;
    .captcha-input {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      img {
        width: 85px;
        height: 36px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
    .title {
      margin: 0 auto;
      padding-top: 200px;
      font-size: 35px;
      font-weight: 700;
      color: white;
      text-align: center;
      margin-bottom: 25px;
    }
    .identityContainer,
    .loginForm,
    .forgotForm {
      position: relative;
      margin: 0 auto;
      background-color: rgba(255, 255, 255, 0.342);

      width: 360px;
      border: 1px solid #e3e3e3;
      border-radius: 10px;
      padding: 20px 20px;
      color: #666;
      .switch,
      .switch_second {
        position: absolute;
        width: 40px;
        right: -1px;
        cursor: pointer;
        top: -3px;
      }
      .switch_second {
        width: 50px;
        right: -4px;
        top: -4px;
        border-top-right-radius: 22px;
      }
      .actionBar {
        margin-top: -2px;
        margin-bottom: 25px;
        display: flex;
        justify-content: space-between;
        color: white;
      }
      .code-input {
        display: flex;
        .btn {
          background-color: #fff;
          border-color: #d2d6de;
          color: #555;
          margin-left: 20px;
        }
      }
      .has-feedback {
        margin-bottom: 30px;
        .nav-tabs {
          border-bottom: 1px solid #ddd;
        }
        .nav-tabs > li > a {
          margin-right: 2px;
          line-height: 1.42857143;
          border: 1px solid transparent;
          border-radius: 4px 4px 0 0;
          padding: 10px 15px;
          color: #fff;
          text-decoration: none;
          width: 127px;
          display: block;
        }
        .active {
          a {
            color: #555 !important;
            cursor: default;
            background-color: #fff;
            border: 1px solid #ddd;
            border-bottom-color: transparent;
          }
        }
        ul {
          display: flex;
          justify-content: space-between;
          li {
            padding: 10px 15px;
            border: 1px solid transparent;
          }
        }
      }

      .submit-button {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .text {
        text-align: right;
        margin-top: 35px;
        color: white;
      }
    }
    .identityContainer {
      padding: 20px;
      background-color: #fff;
      width: 450px;
      height: 550px;
      .selectIdList {
        padding: 30px 50px;
        h2 {
          color: black;
          margin-bottom: 25px;
        }
        ::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
          height: 1px;
        }

        ::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 10px;
          //background-color: #8c8c8c;
          background-color: rgba(0, 0, 0, 0.25);
        }

        ::-webkit-scrollbar-track {
          background-color: #f6f6f6;
        }
        ::-webkit-scrollbar-thumb,
        ::-webkit-scrollbar-track {
          border: 0;
        }
        .scroList {
          overflow-y: auto;
          height: 400px;
        }
      }
      .idList {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;
        background-color: rgb(242, 242, 246);
        padding: 10px;
        border-radius: 10px;
        cursor: pointer;
        position: relative;
        .loginTop {
          position: absolute;
          right: 0;
          top: 0;
          color: rgb(64, 158, 255);
          background-color: rgb(220, 229, 246);
          font-size: 8px;
          padding: 3px;
          border-radius: 0 10px 0 10px;
        }
        .list-left {
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            border-radius: 5px;
          }
          span {
            color: black;
            font-weight: 700;
          }
        }
      }
    }
    .idList:first-child {
      margin-top: 0px;
    }
  }
}
.copy-right {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  padding: 10px 0;
}
</style>
